import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { pinAtom, pinMinimizeAtom, pinWindowAtom } from 'src/app/state/atoms';
import { PostMessageEvent, PostMessageEventType, PostMessageTypes } from 'src/types/iesAuth';

/**
 * Hook to initialize Auth process
 *
 * Once the tutor app is loaded we emit event to parent window
 * The parent has to listen for `authToken` type message and emit us back with IES Auth Token
 *
 * TODO: The `*` should be replaced with parent app environment URL
 */

function usePinWindow() {
  const [pins] = useRecoilState(pinAtom);
  const [pinWindowState, setPinWindowState] = useRecoilState(pinWindowAtom);
  const [minimizedState, setMinimizedState] = useRecoilState(pinMinimizeAtom);

  useEffect(() => {
    const pinCount = pins.pins?.length ?? 0;
    const isOpen = pinWindowState ?? false;
    const isMinimized = minimizedState ?? false;

    // Look for event passed from parent named, 'minimize'
    window.addEventListener(
      'message',
      (event: PostMessageEventType) => {
        if (event.data.type === PostMessageTypes.MINIMIZE) {
          console.log('minimize pin window');
          if (pins.pins?.length > 0) {
            setMinimizedState(true);
          }
        }
      },
      false
    );

    if (pinCount > 0 && isOpen && isMinimized) {
      console.log('minimize pin window');
      setPinWindowState(false);
      window.parent.postMessage(
        {
          type: PostMessageEvent.CLOSE_PIN_WINDOW,
        },
        '*'
      );
    } else if (pinCount > 0 && !isOpen && !isMinimized) {
      setPinWindowState(true);
      console.log('show pin window');
      window.parent.postMessage(
        {
          type: PostMessageEvent.SHOW_PIN_WINDOW,
        },
        '*'
      );
    } else if (pinCount === 0 && isOpen) {
      console.log('close pin window');
      setPinWindowState(false);
      setMinimizedState(false);
      window.parent.postMessage(
        {
          type: PostMessageEvent.CLOSE_PIN_WINDOW,
        },
        '*'
      );
    }
  }, [minimizedState, pinWindowState, pins, setMinimizedState, setPinWindowState]);
}

export default usePinWindow;
